import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=117e52e4&scoped=true&"
var script = {}
import style0 from "./copyright.vue?vue&type=style&index=0&id=117e52e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e52e4",
  null
  
)

export default component.exports